"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reset = exports.fail = exports.finish = exports.start = exports.RESET = exports.FAIL = exports.FINISH = exports.START = void 0;
exports.START = "loading/start";
exports.FINISH = "loading/finish";
exports.FAIL = "loading/fail";
exports.RESET = "loading/reset";
var start = function (key) { return ({
    type: exports.START,
    payload: {
        key: key,
    },
}); };
exports.start = start;
var finish = function (key) { return ({
    type: exports.FINISH,
    payload: {
        key: key,
    },
}); };
exports.finish = finish;
var fail = function (key, error) { return ({
    type: exports.FAIL,
    payload: {
        key: key,
        error: error,
    },
}); };
exports.fail = fail;
var reset = function () { return ({
    type: exports.RESET,
    payload: {},
}); };
exports.reset = reset;
